import React from "react";
import {
    AcceptIcon,
    Avatar,
    AvatarStatusProps,
    ChevronStartIcon,
    CloseIcon,
    Flex,
    SubtractIcon,
    Text,
} from "@fluentui/react-northstar";
import { AadUserPresence } from "../enums/AadUserPresence";

export interface AadUserAvataruser {
    fullName?: string;
    base64Photo?: string;
    presence?: AadUserPresence;
    email?: string;
    phoneNumber?: string;
    vertical?: boolean;
}

export const AadUserAvatar: React.FC<AadUserAvataruser> = ({
    fullName,
    base64Photo,
    email,
    phoneNumber,
    vertical,
    presence,
}) => {
    let statusProps: AvatarStatusProps = { icon: <CloseIcon />, state: "unknown" };

    switch (presence) {
        case AadUserPresence.online:
            statusProps = { icon: <AcceptIcon size="largest" />, state: "success" };
            break;

        case AadUserPresence.away:
            statusProps = { icon: <ChevronStartIcon rotate={-30} />, state: "warning" };
            break;

        case AadUserPresence.busy:
            statusProps = { state: "error" };
            break;

        case AadUserPresence.doNotDisturb:
            statusProps = { icon: <SubtractIcon />, state: "error" };
            break;
    }

    return (
        <Flex gap="gap.small" vAlign="center" hAlign="center" column={vertical}>
            <Avatar name={fullName} image={base64Photo} size="larger" status={statusProps} />
            <Flex column hAlign={vertical ? "center" : undefined}>
                {fullName && (
                    <Text size="larger" weight="semibold">
                        {fullName}
                    </Text>
                )}
                {email && <Text>{email}</Text>}
                {phoneNumber && <Text>{phoneNumber}</Text>}
            </Flex>
        </Flex>
    );
};
